'use client';

import { useEffect, useState, RefObject } from 'react';

import { utilEventConfigurableProduct } from '@/fo/util/event-configurable-product';
import { MappedProduct } from '@/fo/util/map-product-data';

import { Actions } from '../components/Actions';
import { PriceInfo } from '../components/PriceInfo';
import { ProductInfo } from '../components/ProductInfo';

import { styles } from './FeatureProductHeaderActions.styles';

export interface FeatureProductHeaderActionsProps {
  product: MappedProduct;
  productInfoRef: RefObject<HTMLDivElement | null>;
  isAuthorized: boolean;
}

export function FeatureProductHeaderActions({
  product: baseProduct,
  productInfoRef,
  isAuthorized
}: FeatureProductHeaderActionsProps) {
  const slots = styles();

  const [isHidden, setIsHidden] = useState(true);

  const [product, setProduct] = useState<MappedProduct>(
    baseProduct.configurableVariants?.find((item) => item.isSelected)
      ?.product || baseProduct
  );

  const handleScroll = () => {
    if (!productInfoRef.current) return;

    const minScrollHeight = productInfoRef.current.getBoundingClientRect().top;

    if (window.pageYOffset > minScrollHeight) {
      setIsHidden(false);
    } else {
      setIsHidden(true);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    const unsubscribeOnProductSelect =
      utilEventConfigurableProduct.onProductSelect((product) => {
        setProduct(product);
      });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      unsubscribeOnProductSelect();
    };
  });

  return (
    <div className={`${slots.base()} ${!isHidden ? slots.showBase() : ''}`}>
      <div className={slots.container()}>
        <ProductInfo
          name={baseProduct.name}
          baseProduct={baseProduct}
          selectedProduct={product}
        />
        <div className={slots.actionWrapper()}>
          <PriceInfo
            basePrice={product.basePrice}
            finalPrice={product.finalPrice}
            stockStatus={product.stockStatus}
            bonusPoints={product.bonusPoints}
            bonusPointsMax={product.bonusPointsMax}
            bonusLabel={product.labelsBonus[0]?.name}
            isAuthorized={isAuthorized}
          />
          <Actions
            product={product}
            parentSku={product.parentSku}
            isAuthorized={isAuthorized}
          />
        </div>
      </div>
    </div>
  );
}
